const FallbackCustomScheme = require('fallback-custom-scheme');

const fcs = new FallbackCustomScheme({
    urlScheme: `${window.i18n.displaysUrlApp}`, // your application custom scheme
    fallback: `${window.i18n.displaysUrlRedirect}`, // if not installed the applicaiton, handling (ex. app store, google play store etc)
    // browserback: 'back',
});

const displaysBtn = document.querySelector('.js-displays-btn');

displaysBtn.addEventListener('click', (e) => {
    e.preventDefault();
    fcs.launch();
});



// WEBPACK FOOTER //
// ./src/js/features/displays.js